module.exports = __webpack_public_path__ + "static/media/55563c3c.jpg";